import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import CustomAmountPriceContainer from './CustomAmountPrice';
import ProductVariant from '@configuratorware/configurator-frontendgui/App/Shared/Containers/ProductVariant';
import ConfigurationModeSwitch from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/ConfigurationModeSwitch';
import { makeStyles } from '@material-ui/core/styles';
import HintDialog from '../Components/HintDialog';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { areHintMessagesDisabled, getActiveHintMessage } from '../Reducers/HintMessages/Selectors';
import { HintMessages } from '../../Enums';
import { jumpToPrevHintMessage } from '../Reducers/HintMessages/Actions';

export const useStyles = makeStyles(
  (theme) => {
    return {
      root: {
        bottom: 0,
        right: 0,
        position: 'absolute',
        [theme.breakpoints.down('xs')]: {
          right: 0,
          left: 0,
        },
        [theme.breakpoints.between('xs', 'sm')]: {
          width: '100%',
        },
        [theme.breakpoints.between('sm', 'xl')]: {
          width: '320px',
        },
      },
      containerRoot: {
        [theme.breakpoints.down('sm')]: {
          width: 320,
          display: 'flex',
          alignSelf: 'end',
        },
      },
    };
  },
  { name: 'AmountPrice' }
);

export const AmountPriceContainer = ({ AmountPriceContainer, showDesigner, ...props }) => {
  const classes = useStyles({ showDesigner });
  const [anchorRef, setAnchorRef] = useState();
  const query = new URLSearchParams(location.search);
  const selectedAmount = query.get('_quantity');
  useEffect(() => {
    if (selectedAmount) {
      Services.configurator.setSelectedAmount(false, Number(selectedAmount), false);
    }
  }, []);
  const wrapperRoot = showDesigner ? '' : classes.root;
  const activeHintMessage = getActiveHintMessage();
  return (
    <div className={classes.containerRoot} style={{}} ref={setAnchorRef}>
      {/* LAN-32 Adding Hint Dialog */}
      {!areHintMessagesDisabled() && activeHintMessage === HintMessages.AddToCartButton && (
        <HintDialog
          offsetDirection={'left'}
          anchorRef={anchorRef}
          offset={-5}
          perpendicularOffset={-40}
          arrowPlacement={'rightBottom'}
          title={t('hintMessages.hint7.title')}
          content={t('hintMessages.hint7.content')}
          onBackClick={() => Services.store.dispatch(jumpToPrevHintMessage())}
        />
      )}
      <AmountPriceContainer wrapperClass={wrapperRoot} {...props} />
    </div>
  );
};

AmountPriceContainer.defaultProps = {
  AmountPriceContainer: CustomAmountPriceContainer,
  ProductVariantComponent: ProductVariant,
  ConfigurationModeSwitchComponent: ConfigurationModeSwitch,
  showConfigurationModeSwitch: false,
  showDesigner: false,
};

AmountPriceContainer.propTypes = {
  AmountPriceContainer: PropTypes.elementType,
  ProductVariantComponent: PropTypes.elementType,
  ConfigurationModeSwitchComponent: PropTypes.elementType,
  showConfigurationModeSwitch: PropTypes.bool,
  showDesigner: PropTypes.bool,
};

export default AmountPriceContainer;
